var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement, useEffect, useRef, useState, } from "react";
import { useTranslation } from "react-i18next";
import { smallSlot } from "@/utils/types/layout";
import { useParams } from "react-router-dom";
import { isWidgetAvailableArea, numberSlotLimit, } from "@/components/forms/components/utils";
import { useFilteredWidgets } from "@/utils/themes/hooks";
import { Slider } from "@mui/joy";
import WidgetPreview from "./widgetPreview";
export default function WidgetEditor(_a) {
    //const taille = selected?.payload?.width || 1;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var selected = _a.selected, update = _a.update, _p = _a.widgetDefinition, widgetDefinition = _p === void 0 ? null : _p, _q = _a.currentSlot, currentSlot = _q === void 0 ? null : _q, onValidationChange = _a.onValidationChange;
    var _r = useState(selected), editedWidget = _r[0], setEditedWidget = _r[1];
    var widgetType = (_d = (_c = (_b = selected === null || selected === void 0 ? void 0 : selected.type) === null || _b === void 0 ? void 0 : _b.split("/")) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : "";
    var availability = isWidgetAvailableArea(selected === null || selected === void 0 ? void 0 : selected.type);
    var isSmallSlot = currentSlot && smallSlot.includes(currentSlot);
    var isAllowedInThisSlot = isSmallSlot
        ? availability.canBeInSmallSlot
        : availability.canBeInBigSlot;
    var _s = useParams(), module = _s.module, action = _s.action;
    var t = useTranslation(["common"]).t;
    useEffect(function () {
        setEditedWidget(selected);
    }, [selected]);
    useEffect(function () {
        update(editedWidget);
    }, [editedWidget]);
    var slot = (_e = selected === null || selected === void 0 ? void 0 : selected.slot) !== null && _e !== void 0 ? _e : currentSlot;
    var direction = ["EAST", "WEST"].some(function (side) { return slot.includes(side); })
        ? "v"
        : "h";
    var taille = (_j = (_g = (_f = selected === null || selected === void 0 ? void 0 : selected.payload) === null || _f === void 0 ? void 0 : _f.width) !== null && _g !== void 0 ? _g : (_h = editedWidget === null || editedWidget === void 0 ? void 0 : editedWidget.payload) === null || _h === void 0 ? void 0 : _h.width) !== null && _j !== void 0 ? _j : 1;
    var defaultSizeOptions = [
        { size: 1, labelKey: "LBL_WIDGET_S", minHeight: "min-h-4" },
        { size: 2, labelKey: "LBL_WIDGET_M", minHeight: "min-h-8" },
        { size: 3, labelKey: "LBL_WIDGET_L", minHeight: "min-h-10" },
        { size: 4, labelKey: "LBL_WIDGET_XL", minHeight: "min-h-12" },
    ];
    var sizeOptions = ((_k = selected === null || selected === void 0 ? void 0 : selected.payload) === null || _k === void 0 ? void 0 : _k.sizeOptions)
        ? (_l = selected === null || selected === void 0 ? void 0 : selected.payload) === null || _l === void 0 ? void 0 : _l.sizeOptions
        : defaultSizeOptions;
    var _t = useState((_o = (_m = selected === null || selected === void 0 ? void 0 : selected.payload) === null || _m === void 0 ? void 0 : _m.width) !== null && _o !== void 0 ? _o : 1), widgetWidth = _t[0], setWidgetWidth = _t[1];
    var filteredWidgets = useFilteredWidgets(slot);
    var totalSlotWidth = filteredWidgets.reduce(function (sum, widget) { var _a, _b; return sum + ((_b = (_a = widget.payload) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : 1); }, 0);
    var initialWidth = useRef(taille);
    var otherWidgetsWidth = totalSlotWidth - widgetWidth;
    var remainingWidth = numberSlotLimit - totalSlotWidth;
    var isDisabled = function (size) {
        //Case for New widget
        if (currentSlot) {
            return size > remainingWidth;
        }
        //Change a widget
        if (size <= widgetWidth)
            return false;
        if (size <= initialWidth.current)
            return false;
        if (otherWidgetsWidth + size <= numberSlotLimit)
            return false;
        return true;
    };
    var allSizesDisabled = sizeOptions.every(function (_a) {
        var size = _a.size;
        return isDisabled(size);
    });
    var disableSizeSelector = !isAllowedInThisSlot || allSizesDisabled;
    useEffect(function () {
        if (onValidationChange) {
            onValidationChange(disableSizeSelector);
        }
    }, [allSizesDisabled, isAllowedInThisSlot]);
    var min = Math.min.apply(Math, sizeOptions.map(function (o) { return o.size; }));
    var max = Math.max.apply(Math, sizeOptions.map(function (o) { return o.size; }));
    var allowedValues = sizeOptions.map(function (o) { return o.size; });
    var handleChange = function (_, value) {
        var raw = Array.isArray(value) ? value[0] : value;
        var size = allowedValues.reduce(function (prev, curr) {
            return Math.abs(curr - raw) < Math.abs(prev - raw) ? curr : prev;
        });
        if (isDisabled(size))
            return;
        setWidgetWidth(size);
        setEditedWidget(__assign(__assign({}, editedWidget), { payload: __assign(__assign({}, editedWidget.payload), { width: size }) }));
    };
    return (_jsx(_Fragment, { children: widgetDefinition && (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "bg-gray-50 min-h-4 border-x-2 border-gray-300 p-2" }, { children: [_jsx("h2", __assign({ className: "font-bold" }, { children: widgetDefinition === null || widgetDefinition === void 0 ? void 0 : widgetDefinition.name })), _jsx("p", { children: widgetDefinition === null || widgetDefinition === void 0 ? void 0 : widgetDefinition.description }), _jsxs("div", __assign({ className: "mt-4" }, { children: [_jsx("label", __assign({ className: "font-bold" }, { children: t("app.LBL_WIDGET_WIDTH", { ns: "common" }) })), allSizesDisabled && (_jsx("p", __assign({ className: "text-[var(--colors-danger-outlinedColor)] text-sm font-semibold mt-1" }, { children: t("app.LBL_WIDGET_SIZE_LIMIT", { ns: "common" }) }))), _jsxs("div", __assign({ className: "w-full px-4 py-5" }, { children: [_jsx("div", __assign({ className: "relative h-2 mb-1" }, { children: sizeOptions.map(function (_a, index) {
                                                var size = _a.size, labelKey = _a.labelKey;
                                                var left = ((size - min) / (max - min)) * 100;
                                                var isFirst = index === 0;
                                                var isLast = index === sizeOptions.length - 1;
                                                return (_jsx("span", __assign({ className: "\n                          absolute text-sm font-semibold whitespace-nowrap\n                          ".concat(disableSizeSelector || isDisabled(size)
                                                        ? "opacity-50 cursor-not-allowed text-gray-400"
                                                        : widgetWidth === size
                                                            ? "text-blue-600"
                                                            : "cursor-pointer hover:text-blue-500 text-gray-500", "\n                          ").concat(widgetWidth === size && !disableSizeSelector
                                                        ? "text-blue-600"
                                                        : "text-gray-500", "\n                          ").concat(isFirst ? "left-0 text-left" : "", "\n                          ").concat(isLast ? "right-0 text-right" : "", "\n                          ").concat(!isFirst && !isLast ? "-translate-x-1/2" : "", "\n                        "), style: !isFirst && !isLast ? { left: "".concat(left, "%") } : undefined, onClick: function () {
                                                        if (disableSizeSelector)
                                                            return;
                                                        setWidgetWidth(size);
                                                    } }, { children: t("app.".concat(labelKey), { ns: "common" }) }), size));
                                            }) })), _jsx(Slider, { min: min, max: max, step: null, value: widgetWidth, disabled: disableSizeSelector, marks: sizeOptions.map(function (o) { return ({ value: o.size }); }), onChange: handleChange, size: "md", sx: {
                                                "& .MuiSlider-thumb": {
                                                    bgcolor: "white",
                                                    border: "2px solid #3b82f6",
                                                },
                                                "& .MuiSlider-track": {
                                                    bgcolor: "#3b82f6",
                                                },
                                                "& .MuiSlider-rail": {
                                                    bgcolor: "#d1d5db",
                                                },
                                                "&.Mui-disabled": {
                                                    opacity: 0.5,
                                                    cursor: "not-allowed",
                                                },
                                            } }), !isAllowedInThisSlot ? (_jsx("div", __assign({ className: "text-red-500 text-center mt-2 italic text-sm" }, { children: t("app.LBL_WIDGET_CANNOT_ADD_SMALL_SLOT", {
                                                ns: "common",
                                            }) }))) : (_jsx(WidgetPreview, { disabled: allSizesDisabled, name: widgetType, size: widgetWidth, direction: direction }))] }))] }))] })), _jsxs("div", __assign({ className: "bg-gray-100 min-h-4 p-2" }, { children: [_jsx("h2", __assign({ className: "font-bold" }, { children: t("app.LBL_WIDGET_SETTINGS", { ns: "common" }) })), widgetDefinition.settings &&
                            createElement(widgetDefinition.settings, {
                                widget: editedWidget,
                                onChange: function (widget, payload) {
                                    setEditedWidget(__assign(__assign({ id: (editedWidget === null || editedWidget === void 0 ? void 0 : editedWidget.id) || "", type: (editedWidget === null || editedWidget === void 0 ? void 0 : editedWidget.type) || "" }, (editedWidget || {})), { payload: __assign(__assign({}, editedWidget === null || editedWidget === void 0 ? void 0 : editedWidget.payload), payload) }));
                                },
                            })] }))] })) }));
}
